import { Phone, MessageCircle, CalendarCheck } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';
import { BookNowButton } from './BookNowButton';
import { whatsappUrl, CALL_TEL } from './constants';

export const MobileActionBar = () => {
  const { t } = useLang();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-[1fr_1fr_1.6fr] bg-ink/95 backdrop-blur-md border-t border-white/10 h-16">
      <a href={CALL_TEL} className="flex flex-col items-center justify-center gap-0.5 text-white/80 active:bg-white/5" data-testid="sticky-call-button">
        <Phone size={20} className="text-gold" />
        <span className="text-[10px] uppercase tracking-wider">{t.hero.call}</span>
      </a>
      <a href={whatsappUrl(t.whatsappMsg)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-0.5 text-white/80 active:bg-white/5 border-x border-white/10" data-testid="sticky-whatsapp-button">
        <MessageCircle size={20} className="text-[#25D366]" />
        <span className="text-[10px] uppercase tracking-wider">WhatsApp</span>
      </a>
      <BookNowButton
        testId="sticky-book-now-button"
        className="flex items-center justify-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest text-sm"
      >
        <CalendarCheck size={18} /> {t.nav.bookNow}
      </BookNowButton>
    </div>
  );
};
